export default __webpack_public_path__ + "static/media/payoutIcon.965ea317.png";